import script from "./RegisterGroupItemOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterGroupItemOptions.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./RegisterGroupItemOptions.vue?vue&type=style&index=1&id=bb11ded8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb11ded8"]])

export default __exports__